export class AnalysisDateSlider {
  constructor({ minInput, maxInput, display, container, onStop }) {
    this.minInput = minInput;
    this.maxInput = maxInput;
    this.display = display;
    this.container = container;
    this.onStop = onStop;
    this.init = false;
    this.enabled = true;

    [this.minInput, this.maxInput].forEach((input) => {
      input?.addEventListener('input', () => this.syncFromInputs());
      input?.addEventListener('change', () => this.handleStop());
    });
  }

  initialize() {
    const minVal = parseInt(document.getElementById('analysisEarliestDate')?.value, 10);
    const maxVal = parseInt(document.getElementById('analysisLatestDate')?.value, 10);
    const curYear = new Date().getFullYear();

    if (this.minInput && this.maxInput) {
      this.minInput.min = minVal;
      this.minInput.max = maxVal;
      this.maxInput.min = minVal;
      this.maxInput.max = maxVal;
      this.minInput.value = (maxVal > curYear ? curYear : maxVal) - 20;
      this.maxInput.value = curYear;
    }

    this.updateDisplay();
    this.init = true;
    return this;
  }

  syncFromInputs() {
    if (!this.minInput || !this.maxInput) return;

    let min = parseInt(this.minInput.value, 10);
    let max = parseInt(this.maxInput.value, 10);
    if (min > max) {
      if (document.activeElement === this.minInput) {
        max = min;
        this.maxInput.value = max;
      } else {
        min = max;
        this.minInput.value = min;
      }
    }
    this.updateDisplay();
  }

  handleStop() {
    this.syncFromInputs();
    this.setEnabled(false);
    this.onStop?.();
  }

  setValues(getSettings, dataSets = {}) {
    const x = getSettings().x;
    if (x === 'award_date' || x === 'online_date') {
      this.show();
      const range = [];
      Object.values(dataSets).forEach((dataset) => {
        range.push(parseInt(dataset.date_range_end, 10));
        range.push(parseInt(dataset.date_range_start, 10));
      });

      range.sort((a, b) => a - b);
      const min = range.shift();
      const max = range.pop();
      if (this.minInput && this.maxInput && min && max) {
        const sliderMax = parseInt(this.maxInput.max, 10);
        this.minInput.min = min;
        this.maxInput.min = min;
        this.minInput.max = max > sliderMax ? max : sliderMax;
        this.maxInput.max = max > sliderMax ? max : sliderMax;
      }
      this.updateDisplay();
    } else {
      this.hide();
    }
  }

  getValues() {
    if (this.container && !this.container.hidden && this.container.style.display !== 'none') {
      return [parseInt(this.minInput?.value, 10), parseInt(this.maxInput?.value, 10)];
    }
    return [];
  }

  isVisible() {
    return this.container && !this.container.hidden && this.container.style.display !== 'none';
  }

  setEnabled(enabled) {
    this.enabled = enabled;
    [this.minInput, this.maxInput].forEach((input) => {
      if (input) input.disabled = !enabled;
    });
  }

  show() {
    if (this.container) {
      this.container.hidden = false;
      this.container.style.display = '';
    }
  }

  hide() {
    if (this.container) {
      this.container.hidden = true;
      this.container.style.display = 'none';
    }
  }

  updateDisplay() {
    if (this.display && this.minInput && this.maxInput) {
      this.display.innerHTML = `${this.minInput.value} &ndash; ${this.maxInput.value}`;
    }
  }
}
